<template>
    <div class="mobile-card">
        <div class="card-title" :style="titleStyle" v-if="showTitle">
            <div class="card-title-div">
                <slot name="title"></slot>
            </div>
        </div>
        <!-- <div v-if="showTitle" class="mobile-title-card-line"></div> -->
        <div v-if="showTitle" class="van-hairline--top"></div>
        <div class="card-content" :style="{paddingTop:paddingTop?paddingTop:''}">
            <slot name="content"></slot>
        </div>
        <div class="card-footer" v-if="showFooter">
            <div class="mobile-card-line van-hairline--top"></div>
            <slot name="footer"></slot>
        </div>
    </div>
</template>
<script>
    export default {
        name: "mobileCard",
        props: {
            showFooter: {
                type: Boolean,
                default: false,
            },
            showTitle: {
                type: Boolean,
                default: true,
            },
            titleColor: {
                type: String,
            },
            paddingTop: {
                type: String,
            },
		},

        data() {
            return {}
		},

        computed: {

            titleStyle() {
                if (this.titleColor) {
                    return {
                        background: this.titleColor,
                    }
                }
                return {}
            }
        },
    }
</script>
<style lang="scss" scoped>

</style>
